import { render, staticRenderFns } from "./bigReport.vue?vue&type=template&id=6f72288b&scoped=true&"
import script from "./bigReport.vue?vue&type=script&lang=js&"
export * from "./bigReport.vue?vue&type=script&lang=js&"
import style0 from "./bigReport.vue?vue&type=style&index=0&id=6f72288b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f72288b",
  null
  
)

export default component.exports